export const formatCurrency = function (value) {
  const floatValue = parseFloat(value);
  if(!isNaN(floatValue)){
    //Format currency field upto 2
    return floatValue.toFixed(2);
  }
  return value;
};